export default __webpack_public_path__ + "static/media/polygon.6e808c42.png";